import React from "react";
import { getAtributo } from "../../../context/FuncionesContext";

const Default = ({ data, cab, hijos, campokey, id_elemento }) => {
  const nombre = getAtributo('nombre', data, cab);
  const defaultValue = getAtributo("default", data, cab);
  const className = getAtributo("className", data, cab);

  return (
    <>
      <div id={id_elemento} className="tarjeta_grid_item_label_item">
        {nombre && nombre.trim() !== "" ? (
          <div className="vista_label vista_label_fuente">{nombre}:</div>
        ) : (
          <></>
        )}
        <div
          className={className}
          style={{ width: cab.width }}
        >
          <div style={{ textAlign: cab.align }}>
            {data[campokey] ?? defaultValue}
          </div>
        </div>
      </div>
      {hijos?.map((hijo) => hijo)}
    </>
  );
};

export default Default;
